export default __webpack_public_path__ + "static/media/loader.9ea7e5ec.svg";